const {Component} = require("react");
const PropTypes = require("prop-types");
const PublicInvoiceOption = require("app/components/checkout/steps/payment/PublicInvoiceOption");
const PrivateInvoiceOption = require("app/components/checkout/steps/payment/PrivateInvoiceOption");
const {pluckKeysExcept} = require("app/util/object");
const Option = require("app/components/checkout/steps/payment/Option");
const env = require("app/services/env");
const { numberFormat } = require('app/util/formaters');
const Trans = require('app/components/trans/Trans');

class Selector extends Component {

    static get propTypes() {
        return {
            value: PropTypes.string,
            cart: PropTypes.object.isRequired,
            onChange: PropTypes.func
        };
    }

    static get defaultProps() {
        return {
            value: "bambora"
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            value: props.value || this.constructor.defaultProps.value,
            cart: props.cart
        };
    }

    componentWillReceiveProps(nextProps) {
        let payload = {};

        if (nextProps.value !== this.props.value) {
            payload.value = nextProps.value || this.constructor.defaultProps.value;
        }

        if (nextProps.cart !== this.state.cart) {
            payload.cart = nextProps.cart;
        }

        if (Object.keys(payload).length > 0) {
            this.setState(payload);
        }
    }

    get value() {
        return this.state.value;
    }

    get options() {
        const options = [];
        if (env.get('checkout.payment.show_payment_method_bambora', true)) {
            options.push({
                id: "bambora",
                title: translate("Betalingskort"),
                description: translate("Vi tager imod en bred vifte af betalingskort. Eks. Visa, Maestro, Discover, American Express."),
                image: "img/card_payments.png",
            })
        }

        if (env.get('checkout.payment.show_payment_method_mobilepay', true)) {
            options.push({
                id: "mobilepay",
                title: translate("Mobilepay"),
                description: translate("Vi tager også imod betaling via Mobilepay."),
                image: "img/mobilepay_payments.png",
            })
        }

        if (env.get('checkout.payment.show_payment_method_paypal', true)) {
            options.push({
                id: "paypal",
                title: translate("PayPal"),
                description: translate("Vi tager også imod betaling via PayPal."),
                image: "img/paypal_payments.png",
            });
        }

        if (env.get('checkout.payment.show_payment_method_viabill', true)) {
            options.push({
                id: "viabill",
                title: translate("Viabill"),
                description: translate("Vi tager også imod betaling via Viabill."),
                image: "img/viabill_payments.png",
            });
        }
        
        if (env.get('checkout.payment.show_payment_method_invoice', true)) {
            options.push({
              id:          "invoice",
              title: translate("Faktura til Erhverv - (:invoiceFee i gebyr)", {invoiceFee: numberFormat(env.get('checkout.invoiceFee', 25))}),
              description: "",
              component:   PrivateInvoiceOption
            });
        }

        if (env.get('checkout.payment.show_payment_method_ean_invoice', true)) {
            options.push({
                id: "ean_invoice",
                title: translate("Faktura til det offentlige"),
                description: "",
                component: PublicInvoiceOption
            })
        }


        return options;
    }

    _onSelect = (value) => {
        this.setState({value});

        if (typeof this.props.onChange === "function") {
            this.props.onChange(value);
        }
    };

    renderOptions() {
        return this.options.map(option => {
            const OptionComponent = option.component || Option;
            const props = pluckKeysExcept(option, ["component"]);

            return (<OptionComponent key={option.id} cart={this.props.cart} onSelect={this._onSelect}
                                     selected={this.value === option.id} {...props}/>)
        });
    }

    render() {
        return (
            <div className="payment-type-selector">
                <div className="section-title"><Trans>Vælg betalingsmetode</Trans></div>
                {this.renderOptions()}
            </div>
        );
    }

}

module.exports = Selector;
